import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public year: any;
  urlBaseS3: any = (<any>params).api.s3;
  @Input('sociaMedia') public sociaMedia = [];
  @Input('loadServ') public loadServ: boolean = true;
  @Input('data') public generalData: any = [];
  constructor(private _homeService: HomeService) {
    this.year = new Date().getFullYear();
  }

  ngOnInit() {
    if (this.loadServ) {
      this.getGeneralOptions();
    }
  }
  getGeneralOptions() {
    this._homeService.getGeneralOptions().subscribe(data => {

      const social_media = [];
      // tslint:disable-next-line: forin
      if (data.data) {
        for (const prop in data.data.socials.data) {
          if (prop !== 'options') {
            social_media.push(data.data.socials.data[prop]);
          }
        }
      }
      this.sociaMedia = social_media;
      this.generalData = data.data;

      if (!(data.data && data.data.length > 0)) {
        console.warn('Sin data general');
      }
    }, err => {
      console.error(err);
    });
  }
}
